import { Box, styled } from "@mui/material";

export const FormContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "1rem",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "2rem",
  flexWrap: "wrap",
  justifyContent: "center",
  "> div": {
    flexBasis: "49%",
    [theme.breakpoints.down("md")]: {
      flexBasis: "100%",
    },
  },
  position: "relative",
}));

export const SubmitWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    marginTop: "2rem",
}));
